require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/fn/object/assign.js
// module id = ySKw
// module chunks = 0